// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-navs1{
    --bs-nav-tabs-border-width:none!important; 
       --bs-nav-tabs-border-color: none; 
       --bs-nav-tabs-border-radius: none; 
       --bs-nav-tabs-link-hover-border-color:none; 
       --bs-nav-tabs-link-active-color:none ; 
       --bs-nav-tabs-link-active-bg:none ; 
       --bs-nav-tabs-link-active-border-color:none ; 
       border-bottom:none!important;
       --bs-nav-link-color: none; 
        --bs-nav-link-hover-color: none; 
        --bs-nav-link-disabled-color:none;
        --bs-nav-link-padding-x: 0;
  }

  .custom-navs1:active{
    border-image-source: linear-gradient(to left,#00C853,#B2FF59);
  }
  .custom-accordion1{
    --bs-nav-link-color:#121111; 
    --bs-accordion-btn-focus-box-shadow:none;
    border: none;
    --bs-accordion-border-color: none!important;
     
  }
  .custom-acrdn-btn1{
    background-color:white!important; 
    padding-bottom: 5px !important;
    color: gray ;
  }
  .sort-data{
    background-color:#f2f2f2!important;
    padding-bottom: 5px !important;
    color: gray;
    font-size: 16px;
  }
  .sort-data:not(.collapsed){
    font-weight:normal !important;
  }
  .custom-acrdn-btn1:focus{
   
       box-shadow: none!important; 
  }
  .custom-acrdn-btn1::after{
    padding-right:30px
    ;
  }
  
  .custom-acrdn-btn1:not(.collapsed) {
    color: #808080!important;
    font-weight:bolder;
    box-shadow:none!important;
    } 
  
  .custom-navs1 .nav-link.active {
    border-bottom: 2px solid;
    border-image:  linear-gradient(to left,#00C853,#B2FF59);
    border-image-slice: 1;}
  
  .custom-navs1 .nav-link {
    cursor: pointer;
  }
  .blue-title{
    font-weight: 600;
    color: #5c5a5a!important;
  }

.li-cursor:hover{
  background: #000;
  color: #fff!important;
  border-radius: 2px;
  font-weight: 500;
  max-width: max-content;

}
.custom-body1{
  background-color:inherit;
  padding:0!important;
}
.accordian-sort{
  background-color:#f7f7f7!important;
}
.custom-text{
  columns: #1A1A1A !important;
  font-size: 12px Goldplay !important;
  padding: 3px,0px,0px !important;
  font-weight: 100;
}
.doneimg{
  width: 15px;
}
/* .scrollable{
  overflow-y: auto;
  height: calc(64vh - 100px);
  overflow-x: hidden;
}
.scrollableDelete{
  overflow-y: auto;
  height: calc(64vh - 100px);
  overflow-x: hidden;
} */
.scrollableDone{
  overflow-y: auto;
  height: calc(80vh - 145px);
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 10px; /* Width of the scrollbar */
  }

  /* Customize scrollbar thumb (the draggable handle) */
  &::-webkit-scrollbar-thumb {
    background-color: #888; /* Color of the thumb */
    border-radius: 5px; /* Rounded corners */
  }

  /* Customize scrollbar track when hovered */
  &::-webkit-scrollbar-track:hover {
    background-color: #f0f0f0; /* Change color on hover */
  }

  /* Customize scrollbar thumb when hovered */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Change thumb color on hover */
  }
}
.update-position1{
  position: relative;
  left: 36px;
}
.mini-check{
  width: 14px;
  height: 14px;
}

.fsize{
  font-size:12px;
   font-weight: 500;
   width: 5%;
}
.complete span{
  position: relative;
  
}
.complete p{
  position: absolute;
  
}
.text-position{
  position: relative;
}
.text-position p{
  position: absolute;
}
/* .comment-position{
  position: relative;
} */
.comment-position p{
  position: relative;
  left: 39px;
}
@media screen and (max-width:576px)  {
  .update-position1{
    left: 0px
  }
  .padding-done{
    padding: 0px !important;
  }
  .scrollableDone{
    &::-webkit-scrollbar {
      width: 3px;
    }
  }
}
@media screen and (min-width:577px) and (max-width:1200px) {
  .update-position1{
    left: 0px
  }
  /* .padding-d{
    padding: 0px !important;
  } */
}`, "",{"version":3,"sources":["webpack://./src/Components/todos/miniDone.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;OACtC,gCAAgC;OAChC,iCAAiC;OACjC,0CAA0C;OAC1C,qCAAqC;OACrC,kCAAkC;OAClC,4CAA4C;OAC5C,4BAA4B;OAC5B,yBAAyB;QACxB,+BAA+B;QAC/B,iCAAiC;QACjC,0BAA0B;EAChC;;EAEA;IACE,6DAA6D;EAC/D;EACA;IACE,2BAA2B;IAC3B,wCAAwC;IACxC,YAAY;IACZ,2CAA2C;;EAE7C;EACA;IACE,gCAAgC;IAChC,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,kCAAkC;IAClC,8BAA8B;IAC9B,WAAW;IACX,eAAe;EACjB;EACA;IACE,6BAA6B;EAC/B;EACA;;OAEK,0BAA0B;EAC/B;EACA;IACE;IACA;EACF;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB;;EAEF;IACE,wBAAwB;IACxB,uDAAuD;IACvD,qBAAqB,CAAC;;EAExB;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;AAEF;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;;AAExB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;;;;;;;;;GASG;AACH;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB;IACE,WAAW,EAAE,2BAA2B;EAC1C;;EAEA,qDAAqD;EACrD;IACE,sBAAsB,EAAE,uBAAuB;IAC/C,kBAAkB,EAAE,oBAAoB;EAC1C;;EAEA,2CAA2C;EAC3C;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA,2CAA2C;EAC3C;IACE,sBAAsB,EAAE,gCAAgC;EAC1D;AACF;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;GACb,gBAAgB;GAChB,SAAS;AACZ;AACA;EACE,kBAAkB;;AAEpB;AACA;EACE,kBAAkB;;AAEpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;GAEG;AACH;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE;EACF;EACA;IACE,uBAAuB;EACzB;EACA;IACE;MACE,UAAU;IACZ;EACF;AACF;AACA;EACE;IACE;EACF;EACA;;KAEG;AACL","sourcesContent":[".custom-navs1{\n    --bs-nav-tabs-border-width:none!important; \n       --bs-nav-tabs-border-color: none; \n       --bs-nav-tabs-border-radius: none; \n       --bs-nav-tabs-link-hover-border-color:none; \n       --bs-nav-tabs-link-active-color:none ; \n       --bs-nav-tabs-link-active-bg:none ; \n       --bs-nav-tabs-link-active-border-color:none ; \n       border-bottom:none!important;\n       --bs-nav-link-color: none; \n        --bs-nav-link-hover-color: none; \n        --bs-nav-link-disabled-color:none;\n        --bs-nav-link-padding-x: 0;\n  }\n\n  .custom-navs1:active{\n    border-image-source: linear-gradient(to left,#00C853,#B2FF59);\n  }\n  .custom-accordion1{\n    --bs-nav-link-color:#121111; \n    --bs-accordion-btn-focus-box-shadow:none;\n    border: none;\n    --bs-accordion-border-color: none!important;\n     \n  }\n  .custom-acrdn-btn1{\n    background-color:white!important; \n    padding-bottom: 5px !important;\n    color: gray ;\n  }\n  .sort-data{\n    background-color:#f2f2f2!important;\n    padding-bottom: 5px !important;\n    color: gray;\n    font-size: 16px;\n  }\n  .sort-data:not(.collapsed){\n    font-weight:normal !important;\n  }\n  .custom-acrdn-btn1:focus{\n   \n       box-shadow: none!important; \n  }\n  .custom-acrdn-btn1::after{\n    padding-right:30px\n    ;\n  }\n  \n  .custom-acrdn-btn1:not(.collapsed) {\n    color: #808080!important;\n    font-weight:bolder;\n    box-shadow:none!important;\n    } \n  \n  .custom-navs1 .nav-link.active {\n    border-bottom: 2px solid;\n    border-image:  linear-gradient(to left,#00C853,#B2FF59);\n    border-image-slice: 1;}\n  \n  .custom-navs1 .nav-link {\n    cursor: pointer;\n  }\n  .blue-title{\n    font-weight: 600;\n    color: #5c5a5a!important;\n  }\n\n.li-cursor:hover{\n  background: #000;\n  color: #fff!important;\n  border-radius: 2px;\n  font-weight: 500;\n  max-width: max-content;\n\n}\n.custom-body1{\n  background-color:inherit;\n  padding:0!important;\n}\n.accordian-sort{\n  background-color:#f7f7f7!important;\n}\n.custom-text{\n  columns: #1A1A1A !important;\n  font-size: 12px Goldplay !important;\n  padding: 3px,0px,0px !important;\n  font-weight: 100;\n}\n.doneimg{\n  width: 15px;\n}\n/* .scrollable{\n  overflow-y: auto;\n  height: calc(64vh - 100px);\n  overflow-x: hidden;\n}\n.scrollableDelete{\n  overflow-y: auto;\n  height: calc(64vh - 100px);\n  overflow-x: hidden;\n} */\n.scrollableDone{\n  overflow-y: auto;\n  height: calc(80vh - 145px);\n  overflow-x: hidden;\n  &::-webkit-scrollbar {\n    width: 10px; /* Width of the scrollbar */\n  }\n\n  /* Customize scrollbar thumb (the draggable handle) */\n  &::-webkit-scrollbar-thumb {\n    background-color: #888; /* Color of the thumb */\n    border-radius: 5px; /* Rounded corners */\n  }\n\n  /* Customize scrollbar track when hovered */\n  &::-webkit-scrollbar-track:hover {\n    background-color: #f0f0f0; /* Change color on hover */\n  }\n\n  /* Customize scrollbar thumb when hovered */\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #555; /* Change thumb color on hover */\n  }\n}\n.update-position1{\n  position: relative;\n  left: 36px;\n}\n.mini-check{\n  width: 14px;\n  height: 14px;\n}\n\n.fsize{\n  font-size:12px;\n   font-weight: 500;\n   width: 5%;\n}\n.complete span{\n  position: relative;\n  \n}\n.complete p{\n  position: absolute;\n  \n}\n.text-position{\n  position: relative;\n}\n.text-position p{\n  position: absolute;\n}\n/* .comment-position{\n  position: relative;\n} */\n.comment-position p{\n  position: relative;\n  left: 39px;\n}\n@media screen and (max-width:576px)  {\n  .update-position1{\n    left: 0px\n  }\n  .padding-done{\n    padding: 0px !important;\n  }\n  .scrollableDone{\n    &::-webkit-scrollbar {\n      width: 3px;\n    }\n  }\n}\n@media screen and (min-width:577px) and (max-width:1200px) {\n  .update-position1{\n    left: 0px\n  }\n  /* .padding-d{\n    padding: 0px !important;\n  } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
